import * as yup from 'yup';

// User info validation schema
export const userInfoSchema = yup.object().shape({
  customer_name: yup
    .string()
    .required('Name is required')
    .min(2, 'Name must be at least 2 characters')
    .max(50, 'Name cannot exceed 50 characters')
    .matches(/^[a-zA-Z\s]+$/, 'Name must contain only letters and spaces'),
  customer_email: yup
    .string()
    .required('Email is required')
    .email('Please enter a valid email address'),
  // channel_id: yup
  //   .string()
  //   .required('Channel ID is required'),
});

// Message validation schema
export const messageSchema = yup.object().shape({
  message: yup
    .string()
    .required('Message is required')
    .min(1, 'Message cannot be empty')
    .max(1000, 'Message cannot exceed 1000 characters')
    .trim(),
});

// Export all schemas
export default {
  userInfoSchema,
  messageSchema,
};
